<script setup>
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import { useThemeConfig } from '@core/composable/useThemeConfig'
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { themeConfig } from '@themeConfig'
import authV2ForgotPasswordIllustrationLight from '@/assets/images/pages/auth-v2-forgot-password-illustration-light-new.jpg'
import authV2MaskDark from '@/assets/images/pages/auth-v2-mask-dark.png'
import authV2MaskLight from '@/assets/images/pages/auth-v2-mask-light.png'
import axios from "@axios"
import {
  alphaDashValidator,
  emailValidator,
  requiredValidator
} from '@validators'

const {isAppRtl} = useThemeConfig()
const refVForm = ref()
const email = ref('')
const submitted = ref(false)
const authThemeImg = useGenerateImageVariant(authV2ForgotPasswordIllustrationLight,true)
const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)

const login = () => {
  axios.post('/auth/request-password-reset-email', {
    email: email.value
  }).then(r => {
    submitted.value = true

    return null
  }).catch(e => {
    submitted.value = true
    const {errors: formErrors} = e.response.data
    errors.value = formErrors
    console.error(e.response.data)
  })
}
const onSubmit = () => {
  refVForm.value?.validate().then(({valid: isValid}) => {
    if (isValid)
      login()
  })
}
</script>

<template>
  <div>
    <!-- Title and Logo -->
    <div class="auth-logo d-flex align-start gap-x-3">
      <VNodeRenderer :nodes="themeConfig.app.logo" />

      <!--      <h1 class="font-weight-semibold leading-normal text-2xl text-uppercase"> -->
      <!--        {{ themeConfig.app.title }} -->
      <!--      </h1> -->
    </div>

    <VRow
      class="auth-wrapper"
      no-gutters
    >
      <VCol
        lg="8"
        class="d-none d-lg-flex align-center justify-center position-relative"
      >
        <VImg
          max-width="768px"
          :src="authThemeImg"
          class="auth-illustration"
        />
        <!--        <VImg -->
        <!--          :width="276" -->
        <!--          :src="tree" -->
        <!--          class="auth-footer-start-tree" -->
        <!--        /> -->
        <VImg
          class="auth-footer-mask"
          :src="authThemeMask"
        />
      </VCol>

      <VCol
        cols="12"
        lg="4"
        class="auth-bg d-flex align-center justify-center"
      >
        <VCard
          v-if="!submitted"
          flat
          :max-width="500"
          class="mt-12 mt-sm-0 pa-4"
        >
          <VCardText>
            <h5 class="text-h5 font-weight-semibold mb-1">
              Forgot Password? 🔒
            </h5>
            <p class="mb-0">
              Enter your email and we'll send you instructions to reset your password
            </p>
          </VCardText>

          <VCardText>
            <VForm
              ref="refVForm"
              @submit.prevent="onSubmit"
            >
              <VRow>
                <!-- email -->
                <VCol cols="12">
                  <VTextField
                    v-model="email"
                    autocomplete="email"
                    label="Email"
                    type="email"
                    :rules="[requiredValidator, emailValidator]"
                  />
                </VCol>

                <!-- Reset link -->
                <VCol cols="12">
                  <VBtn
                    block
                    type="submit"
                  >
                    Send Reset Link
                  </VBtn>
                </VCol>

                <!-- back to login -->
                <VCol
                  cols="12"
                  class="text-center"
                >
                  <RouterLink
                    class="text-primary ms-2"
                    to="/home/login"
                  >
                    <VIcon
                      :rotate="isAppRtl ? '180deg' : null"
                      icon="mdi-chevron-left"
                    />
                    <span>Back to login</span>
                  </RouterLink>
                </VCol>
              </VRow>
            </VForm>
          </VCardText>
        </VCard>
        <VCard
          v-else
          flat
          :max-width="500"
          class="mt-12 mt-sm-0 pa-4"
        >
          <VCardText>
            <h5 class="text-h5 font-weight-semibold mb-1">
              Check your email
            </h5>
            <p class="mb-0">
              If you have an approved account with RM, you should receive an email with a link to change your password. Check your spam folder if you don't see an email soon or email us at preferred@reserverm.com. You can close this browser tab.
            </p>
          </VCardText>

          <VCardText />
        </VCard>
      </VCol>
    </VRow>
  </div>
</template>

<style lang="scss">
@use "@core/scss/pages/page-auth.scss";
</style>

<route lang="yaml">
meta:
  layout: blank
  action: read
  subject: Auth
  redirectIfLoggedIn: true
</route>
